import React from 'react'
import { cn } from '../../utils/cn'

interface TableProps extends React.HTMLAttributes<HTMLTableElement> {
 children: React.ReactNode
}

export const Table: React.FC<TableProps> = ({
 children,
 className,
 ...props
}) => {
 return (
 <div className="overflow-x-auto shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
 <table
 className={cn(
 'w-max min-w-full divide-y divide-gray-300',
 className
 )}
 {...props}
 >
 {children}
 </table>
 </div>
 )
}

interface TableHeaderProps extends React.HTMLAttributes<HTMLTableSectionElement> {
 children: React.ReactNode
}

export const TableHeader: React.FC<TableHeaderProps> = ({
 children,
 className,
 ...props
}) => {
 return (
 <thead
 className={cn(
 'bg-surface',
 className
 )}
 {...props}
 >
 {children}
 </thead>
 )
}

interface TableBodyProps extends React.HTMLAttributes<HTMLTableSectionElement> {
 children: React.ReactNode
}

export const TableBody: React.FC<TableBodyProps> = ({
 children,
 className,
 ...props
}) => {
 return (
 <tbody
 className={cn(
 'divide-y divide-border bg-card',
 className
 )}
 {...props}
 >
 {children}
 </tbody>
 )
}

interface TableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
 children: React.ReactNode
 hover?: boolean
}

export const TableRow: React.FC<TableRowProps> = ({
 children,
 hover = false,
 className,
 ...props
}) => {
 return (
 <tr
 className={cn(
 hover && 'hover:bg-surface cursor-pointer',
 className
 )}
 {...props}
 >
 {children}
 </tr>
 )
}

interface TableHeadProps extends React.ThHTMLAttributes<HTMLTableCellElement> {
 children: React.ReactNode
}

export const TableHead: React.FC<TableHeadProps> = ({
 children,
 className,
 ...props
}) => {
 return (
 <th
 className={cn(
 'px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider',
 className
 )}
 {...props}
 >
 {children}
 </th>
 )
}

interface TableCellProps extends React.TdHTMLAttributes<HTMLTableCellElement> {
 children: React.ReactNode
}

export const TableCell: React.FC<TableCellProps> = ({
 children,
 className,
 ...props
}) => {
 return (
 <td
 className={cn(
 'px-6 py-4 whitespace-nowrap text-sm text-foreground',
 className
 )}
 {...props}
 >
 {children}
 </td>
 )
}
